import { useTranslation } from 'react-i18next';
import { CardDiscount } from '@/common/components/CardDiscount/CardDiscount';
import { PageLayoutHorizontalScroll } from '@/common/components/PageLayout/PageLayout';
import { ROUTES } from '@/common/constants/routes';
import { DiscountsList } from '@/common/containers/Dashboard/DiscountsPage/components/DiscountsList/DiscountsList';
import { HomeSection } from '@/common/containers/Dashboard/Home/HomeSection/HomeSection';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';
import { useGetDiscounts } from '@/common/integrations/menhir/employee/discounts/discounts.hooks';
import { useRouter } from 'expo-router';

export function DiscountsSection() {
  const { t } = useTranslation();
  const breakpoints = useBreakpoints(['sm']);
  const router = useRouter();
  const { discounts = [] } = useGetDiscounts();

  if (!discounts.length) {
    return null;
  }

  const filteredDiscounts = discounts.slice(0, 2);
  return (
    <HomeSection
      title={t('wallet.discounts.title')}
      action={{
        children: t('wallet.discounts.see_all'),
        onPress: () => {
          router.navigate(ROUTES.DISCOUNTS);
        },
      }}
    >
      {breakpoints.sm ? (
        <DiscountsList discounts={filteredDiscounts} />
      ) : (
        <PageLayoutHorizontalScroll className="gap-sibling-card">
          {filteredDiscounts.map((discount) => (
            <CardDiscount
              key={discount.id}
              discount={discount}
              className="w-[30rem]"
            />
          ))}
        </PageLayoutHorizontalScroll>
      )}
    </HomeSection>
  );
}
